<template>
    <v-container>
        <v-row>
            <v-col>
                <v-menu v-model="timeMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="selectedTime" color="#c42111" label="Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-model="selectedTime" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds @change="onChange" scrollable />
                </v-menu>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'Time',
    props: ['param'],
    data: () => ({
        selectedTime: TELSA.moment().startOf('day').format("HH:mm:ss"),
        timeMenu: false,
    }),

    computed: {

    },

    methods: {
        onChange: function() {
            this.param.selectedValue = `${this.selectedTime}`;
            this.param.humanText = `${this.selectedTime}`;

            this.$emit('edit');
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            this.selectedTime = TELSA.moment(this.$props.param.encodedValue).format("HH:mm:ss");
        }
    },

    mounted() {
        this.setInputsInitialValue();
        this.onChange();
    },

    watch: {
        selectedTime: {
            handler(newVal, oldVal) {
                this.param.selectedValue = `${this.selectedTime}`;
                this.param.humanText = `${this.selectedTime}`;
            }
        }

    }

  
};
</script>

<style scoped>

</style>

